<template>
  <v-container style="height: 100%; background: #f8f8f8">
    <div class="my-3" style="position: fixed; width: 100%">
      <v-btn icon @click="getBack">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>
    <div class="d-flex align-center" style="height: 100%">
      <div>
        <div class="my-5 px-2">
          <h1>Hai,</h1>
          <h1>Mulai masuk akun</h1>
        </div>
        <div class="my-5 px-2">
          <p>
            Hanya dengan hubungkan dengan akun Google kamu, sudah dapat memesan
            event yang kamu inginkan
          </p>
        </div>
        <div class="my-5 px-2">
          <GoogleLogin
            :params="params"
            :onSuccess="onSuccess"
            :onFailure="onFailure"
            class="google-button mb-5"
            ><v-img
              src="img/google-icon.svg"
              width="24"
              contain
              aspect-ratio="1"
              position="left center"
              class="d-inline-block float-left ml-4"
            />
            Masuk dengan Google</GoogleLogin
          >
          <v-divider />
        </div>
        <p class="px-2 caption grey--text">
          By continuing, I accept the Evenversity
          <a href="">terms of condition</a> and have read the
          <a href="">privacy policy</a>.
        </p>
      </div>
    </div>
  </v-container>
</template>

<script>
import GoogleLogin from 'vue-google-login';
import Axios from 'axios';
export default {
  name: 'Login',
  components: {
    GoogleLogin,
  },
  data() {
    return {
      loading: false,
      error: false,
      errorMessage: false,
      loadData: [],
      params: {
        client_id: process.env.VUE_APP_GOGGLE_ID,
      },
      // only needed if you want to render the button with the google ui
      renderParams: {
        width: 328,
        height: 50,
        longtitle: true,
        // ux_mode: 'redirect',
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem('token') != null) {
      next({
        path: '/',
      });
    } else {
      next();
    }
  },
  methods: {
    onSuccess(googleUser) {
      let profile = googleUser.getBasicProfile();

      Axios.post(process.env.VUE_APP_API + 'auth', {
        name: profile.getName(),
        provider: 'google',
        provider_id: profile.getId(),
        email: profile.getEmail(),
        avatar: profile.getImageUrl(),
      })
        .then((response) => {
          this.loadData = response.data;
          localStorage.setItem('token', response.data.token);
          localStorage.setItem(
            'user_id',
            JSON.stringify(response.data.data.id),
          );
          localStorage.setItem('user', JSON.stringify(response.data.data));
          localStorage.setItem('isLogged', true);
          if (localStorage.getItem('token') != null) {
            this.$emit('loggedIn');
            if (this.$route.query.ref != null) {
              window.location.href = this.$route.query.ref;
              // this.$router.push(this.$route.query.ref);
            } else {
              window.location.href = '/';
              // this.$router.push('/');
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
          this.errorMessage = error;
        })
        .finally(() => (this.loading = false));
    },
    onFailure(e) {
      console.log(e);
    },
    getBack() {
      if (this.$route.query.ref != null) {
        this.$router.go(-1);
      } else {
        window.location.href = '/';
        // this.$router.push('/');
      }
    },
  },
};
</script>

<style scoped>
body {
  background: #f8f8f8;
}
.google-button {
  border-radius: 7px !important;
  width: 100%;
  max-width: 400px;
  border: 1px solid #efefef;
  padding: 12px 0;
  background: #fff;
  box-shadow: 0 0.5rem 1rem rgba(34, 41, 47, 0.15) !important;
}
</style>
